import React from 'react';
import { View, Text, TouchableOpacity, Image, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface FileItem {
  id: number;
  fileUrl?: string;
  label?: string;
  name?: string;
}

interface AttachmentsGridProps {
  files?: FileItem[];
  onPressFile: (file: FileItem) => void;
}

export const AttachmentsGrid: React.FC<AttachmentsGridProps> = ({ files, onPressFile }) => {
  if (!files?.length) {
    return <Text style={styles.empty}>No attachments to show</Text>;
  }

  return (
    <View style={styles.grid}>
      {files?.map((file) => {
        const text = `${file.label || ''} ${file.name || ''} ${file.fileUrl || ''}`.toLowerCase();
        const isImage = text.includes('image') || text.endsWith('.png') || text.endsWith('.jpg') || text.endsWith('.jpeg') || text.endsWith('.gif') || text.endsWith('.webp');
        return (
          <TouchableOpacity key={file.id} style={styles.item} onPress={() => onPressFile(file)}>
            {isImage ? (
              <Image source={{ uri: file.fileUrl }} style={styles.thumb} resizeMode="cover" />
            ) : (
              <SVG_COMPONENTS.PAPERCLIP width={20} height={20} />
            )}
            <Text numberOfLines={2} style={styles.label}>{file.label || file.name}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  empty: {
    color: ADMIN_COLORS.TEXT_TERTIARY,
    fontSize: 12,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  item: {
    width: '48%',
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderRadius: 8,
    padding: 10,
    gap: 8,
  },
  thumb: {
    width: '100%',
    height: 120,
    borderRadius: 6,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  label: {
    color: ADMIN_COLORS.TEXT_SECONDARY,
    fontSize: 11,
  },
});


